export default {

    apiUrl: '/api',
    munisenseApiUrl: 'https://avecodebondt.water-munisense.net/webservices/v2',
    loginUrl: 'https://mijn-aveco.wittigdev.nl/login?app=loggers',
    mijnAvecoUrl: 'https://mijn-aveco.wittigdev.nl/',

    apps: [
        { id: 'mijn-aveco', name: 'Mijn Aveco de Bondt', url: 'https://mijn-aveco.wittigdev.nl' },
        { id: 'monitor', name: 'Monitoringsplatform', url: 'https://aveco-monitor.wittigdev.nl' },
        { id: 'veldwerkwinkel', name: 'Veldwerkwinkel', url: 'https://aveco-veldwerkwinkel.wittigdev.nl' },
        { id: 'loggers', name: 'Loggerdatabase', url: 'https://aveco-loggerdatabase.wittigdev.nl' },
        { id: 'veldwerkdata', name: 'Veldwerkdata', url: 'https://aveco-geveldatabase.wittigdev.nl' },
    ]
}
